var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper d-flex"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('input',_vm._g(_vm._b({class:_vm.value === 1 && !_vm.accessEnable
              ? 'custom-toggleDisable'
              : _vm.value === 2 && !_vm.accessEnable
              ? 'custom-toggleEnable'
              : 'custom-disable',attrs:{"disabled":_vm.accessEnable,"type":"range","name":"points","min":"1","step":"1","max":"2"},domProps:{"value":_vm.value},on:{"change":_vm.filterme}},'input',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.status))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }